import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NavTitle from '../../components/nav-title'
import { Outlet } from 'react-router-dom'
import CardCustom from '../../components/custom/card-custom'
import NavRoleOrg from '../../components/nav-role-org'
import TextNavTitle from '../../components/TextNavTitle'

export default function CheckListPage() {
  return (
    <Row>
      <NavTitle>
        <TextNavTitle>Check List</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <Col xl={12} className="mb-3 ">
        <CardCustom
          className=""
          minHeight=""
          style={{
            height: 'calc(100vh - 130px'
          }}
        >
          <Outlet />
        </CardCustom>
      </Col>
    </Row>
  )
}
